<style lang="scss" scoped>
.inbound-info > span {
	display: inline-block;
	width: 33%;
	padding: 6px 0;
}
/deep/ .ivu-input{
    cursor: pointer;
}
</style>

<template>
	<section class="margin-15 relative">
		<template>
			<div style="margin-bottom: -20px">
				<vButtonGroup v-if="type !== 'query'" class="inline" >
					<vButton theme="primary" @click="addItem">{{$t('global.common.add',{defaultValue:'添加'})}}</vButton>
					<vButton @click="handleUploadData">{{$t('global.common.import',{defaultValue:'导入'})}}</vButton>
					<vButton @click="clearAll">{{$tc('global.common.clear',2,{defaultValue:'清空'})}}</vButton>
				</vButtonGroup>
                <span v-if="type == 'query'">
                    <vFormItem label-width="auto" inline :label="$t('fbb.transfer.skuamount', { defaultValue: 'SKU种类' })+'：'" class="margin-left-10">
                        {{dataList.length || 0}}
                    </vFormItem>
                    <vFormItem label-width="auto" inline :label="$t('fbb.transfer.plandeliveryamount', { defaultValue: '计划出库总数量' })+'：'" class="margin-left-10">
                        {{totalPlanOutCount || 0}}
                    </vFormItem>
                    <vFormItem label-width="auto" inline :label="$t('fbb.transfer.actualdeliveryamount', { defaultValue: '实际出库总数量' })+'：'" class="margin-left-10">
                        {{totalRealOutCount || 0}}
                    </vFormItem>
                    <vFormItem label-width="auto" inline :label="$t('fbb.transfer.panelamount', { defaultValue: '托盘总数' })+'：'" class="margin-left-10">
                        <!-- {{panelList.length || 0}} -->
                        {{ baseData.totalPalletQty || 0}}
                    </vFormItem>
                    <vFormItem label-width="auto" inline style="position: absolute; right: 0">
                        <vButton @click="handleDownload('product')">{{$tc('fbb.alloment.export_detail', { defaultValue: '导出明细' })}}</vButton>
                        <vButton v-if="isManageBill && (baseData.subTransferPlanStatus == 9 || baseData.subTransferPlanStatus == 10)" class="margin-left-10" @click="importExcel">导入托盘明细</vButton>
                    </vFormItem>
                </span>
                <span v-else>
                    <vFormItem label-width="auto" inline :label="$t('fbb.transfer.skuamount', { defaultValue: 'SKU种类' })+'：'" class="margin-left-10">
                        {{dataList.length}}
                    </vFormItem>
                    <vFormItem label-width="auto" inline :label="$t('fbb.transfer.plandeliveryamount', { defaultValue: '计划出库总数量' })+'：'" class="margin-left-10">
                        {{planOutCount}}
                    </vFormItem>
                </span>
			</div>
		</template>
        <Tabs value="name1" :animated="false" v-if="type == 'query'">
            <TabPane :label="$t('fbb.transfer.querybysku', { defaultValue: '按SKU查看' })" name="name1">
                <div style="max-height:200px; overflow: auto">
                    <Table :columns="columns1" size="small" :data="dataList" border></Table>
                </div>
            </TabPane>
            <TabPane :label="$t('fbb.transfer.querybypanel', { defaultValue: '按托盘查看' })" name="name2">
                <div style="max-height:200px; overflow: auto">
                    <Table :columns="columns2" size="small" :data="panelList" border></Table>
                </div>
            </TabPane>
        </Tabs>
        <div style="max-height:200px; overflow: auto">
            <Table v-if="type !== 'query'" :columns="columns" size="small" :data="dataList" border></Table>
        </div>
		<compModal v-model="modalProps.show" v-bind="modalProps" @on-close="modalProps.show=false" @on-confirm="modalProps.show=false">
			<component v-if="modalProps.component" :is="modalProps.component" v-bind="modalProps.props" @on-close="modalProps.show=false" v-on="modalProps.on"/>
		</compModal>
		<vLoading size="large" transfer :loading="loading"></vLoading>
	</section>
</template>

<script>
import { } from '@/service/misc';

import compErpsku from '../markchangecustom/erpsku'

export default {
	props: ['skuData', 'baseData', 'querytype', 'activeid', 'isManage', 'panelData'],
	components: {
		compFormEdit: () => import("@components/templates/formedit"),
		compUpload: () => import("@components/templates/upload"),
		compModal: () => import("@components/templates/modal"),
		compErpsku,
	},
	data() {
		return {
			loading: false,
			type: this.querytype || this.$route.params.type,
			id: this.activeid || this.$route.query.id,
            isManageBill: this.isManage || false,
			formData: {},
			dataList: [],
            panelList: [],
            planOutCount: 0,
            totalPlanOutCount: 0,
            totalRealOutCount: 0,
			modalProps: {
				show: false,
				formdata: null,
			},
		}
	},
	watch: {
        activeid (activeid) {
            if (!activeid) return;
            this.id = activeid;
        },
        skuData(val){
            this.dataList = val;
            this.getOutCount()
            this.totalPlanOutCount = 0;
            this.totalRealOutCount = 0;
            this.dataList.map(item=>{
                this.totalPlanOutCount += item.qty;
                this.totalRealOutCount += item.qtyOutbound;
            })
        },
        panelData(val){
            this.panelList = val;
        }
	},
	computed: {
		columns() {
			return [
                {
                    renderHeader:(h,params)=>{
                        return h('div',[
                            h('Icon',{
                                props:{
                                    type:"ios-medical",
                                    color:"#ed3f14"
                                },
                            }),
                            h('span','ERP SKU')
                        ])
                    },
                    key: 'sku',
                    render: (h, { row }) => {
                        return this.type !== 'query' ?
                        <div onClick={this.handleSkuErp.bind(this, row._index)}>
                            <Input value={row.sku} readonly >
                                <Icon style="cursor: pointer;" slot="suffix" type="md-search" nativeOnClick={this.handleSkuErp.bind(this, row._index)}></Icon>
                            </Input>
                        </div> : <div>{ row.sku || '--'}</div>
                    }
                },
                {
                    title: this.$t('fbb.transfer.productnamechen', { defaultValue: '产品名称(中/英)' }),
                    key: 'productName',
                    render: (h, { row }) => {
                        return <div>
                            <div>
                                <Tooltip placement="top" max-width="200">
                                    <div slot="content">
                                        {row.productName}
                                    </div>
                                    {row.productName.length > 20 ? row.productName.slice(0,20).concat('...') : row.productName || "--"}
                                </Tooltip>
                            </div>
                            <div>
                                <Tooltip placement="top" max-width="200">
                                    <div slot="content">
                                        {row.productNameEn}
                                    </div>
                                    {row.productNameEn.length > 20 ? row.productNameEn.slice(0,20).concat('...') : row.productNameEn || "--"}
                                </Tooltip>
                            </div>
                        </div>
                    }
                },
                {
                    renderHeader:(h,params)=>{
                        return h('div',[
                            h('Icon',{
                                props:{
                                    type:"ios-medical",
                                    color:"#ed3f14"
                                },
                            }),
                            h('span', this.$t('fbb.alloment.plan_out_bound', { defaultValue: '计划出库数量' }))
                        ])
                    },
                    render:(h,{ row, index })=>{
                        if(this.querytype == 'query'){
                            return <div>{row.qty}</div>
                        }else{
                            return h('vInputNumber',{
                                props: {
                                    size:'small',
                                    value:row.qty || 0,
                                    min: 0,
                                    math: "floor",
                                },
                                on: {
                                    'input':(event) => {
                                        this.setPlanOutNumber(event, index)
                                    }
                                },
                            })
                        }
                    }
                },
                {
                    title: this.$t('global.common.operation', { defaultValue: "操作" }),
                    width: 120,
                    align: 'center',
                    render: (h, { row, index }) => {
                        return h('Button', {
                            nativeOn: {
                                click: () => {
                                    this.removeItems(index)
                                }
                            }
                        }, this.$t('global.common.delete', { defaultValue: "删除" }))
                    }
                }
            ]
		},
        columns1() {
			let data = [
                {
                    title: 'ERP SKU',
                    key: 'sku',
                    render: (h, { row }) => {
                        return <div>{ row.sku || '--'}</div>
                    },
                },
                {
                    title: this.$t('fbb.transfer.productnamechen', { defaultValue: '产品名称(中/英)' }),
                    key: 'productName',
                    render: (h, { row }) => {
                        return <div>
                            <div>
                                <Tooltip placement="top" max-width="200">
                                    <div slot="content">
                                        {row.productName}
                                    </div>
                                    {row.productName.length > 20 ? row.productName.slice(0,20).concat('...') : row.productName || "--"}
                                </Tooltip>
                            </div>
                            <div>
                                <Tooltip placement="top" max-width="200">
                                    <div slot="content">
                                        {row.productNameEn}
                                    </div>
                                    {row.productNameEn.length > 20 ? row.productNameEn.slice(0,20).concat('...') : row.productNameEn || "--"}
                                </Tooltip>
                            </div>
                        </div>
                    }
                },
                {
                    title: this.$t('erp.setting.goods_size', { defaultValue: '单品包装尺寸(inch)' }),
                    render: (h, { row }) => {
                        return <div>{this.handleUnit(row.length, 'cm', 'inch') || 0}*{this.handleUnit(row.width, 'cm', 'inch') || 0}*{this.handleUnit(row.height, 'cm', 'inch') || 0}</div>
                    },
                    width: 113,
                },
                {
                    title: this.$t('erp.setting.goods_weight', { defaultValue: '毛重(lb)' }),
                    key: 'weight',
                    render: (h, { row }) => {
                        return <div>{this.handleUnit(row.weight, 'g', 'lb') || 0}</div>
                    },
                    width: 90,
                },
				{
                    title: this.$t('fbb.alloment.plan_out_bound', { defaultValue: '计划出库数量' }),
                    key: 'qty',
                    render: (h, { row }) => {
                        return  <div>{row.qty || 0}</div>
                    },
                    width: 110
                },
                {
                    title: this.$t('fbb.alloment.actual_out_bound', { defaultValue: '实际出库数量' }),
                    key: 'qtyOutbound',
                    render: (h, { row }) => {
                        return  <div>{row.qtyOutbound || 0}</div>
                    },
                    width: 110
                },
                {
                    title: this.$t('global.common.update_time', { defaultValue: '更新时间' }),
                    key: 'updatedAt',
                    render: (h, { row }) => {
                        return  <div>{row.updatedAt || '--'}</div>
                    }
                },
            ];
            if(!this.isManage){
                data.splice(2,2)
                return data
            }
            return data
		},
        columns2() {
			return [
                {
                    title: this.$t('fbb.transfer.panelno', { defaultValue: '托盘NO' }),
                    key: 'palletBarcode',
                    render: (h, { row }) => {
                        return <div>{ row.palletBarcode || '--'}</div>
                    },
                    width: 120
                },
                {
                    title: this.$t('fbb.truck.palletsize', { defaultValue: '托盘尺寸' })+'(inch)',
                    key: 'palletLength',
                    render: (h, { row }) => {
                        return <div>
                            {row.palletLength || 0}*{row.palletWidth || 0}*{row.palletHeight || 0}
                        </div>
                    },
                    width: 120
                },
				{
                    title: this.$t('fbb.transfer.palletweight', { defaultValue: '托盘重量' })+"(lb)",
                    key: 'palletWeight',
                    render: (h, { row }) => {
                        return  <div>{row.palletWeight || 0}</div>
                    },
                    width: 120
                },
                {
                    title: "SKU",
                    key: 'sku',
                    render: (h, { row }) => {
                        return  <div>{row.sku || '--'}</div>
                    }
                },
                {
                    title: this.$t('fbb.transfer.palletamount', { defaultValue: '数量/托' }),
                    key: 'qty',
                    render: (h, { row }) => {
                        return  <div>{row.qty || 0}</div>
                    },
                    width: 80
                },
                {
                    title: this.$t('global.common.update_time', { defaultValue: '更新时间' }),
                    key: 'updatedAt',
                    render: (h, { row }) => {
                        return  <div>{row.updatedAt || '--'}</div>
                    }
                },
            ]
		}
	},

	methods: {
        handleDownload(type) {
			const urlMap = {
				'product': '/api/v2/TransferOutboundPlanItem/batchExport',
				'boxing': '/api/v2/TransferOutboundPlanBoxItem/exportPackages',
			}
			this.handleWebfs(process.env.VUE_APP_APIURL_FBB + urlMap[type], { id: this.isManageBill ? this.baseData.headId : this.id, }, 'download');
		},
        importExcel(){
            this.modalProps = {
                show: true,
                title: this.$t('fbb.transfer.exportpaneldetail', { defaultValue: '导入托盘明细' }),
                width:460,
                showFooter: false,
                component: "compUpload",
                props: {
                    action: process.env.VUE_APP_APIURL_FBB + "/api/v2/TransferOutboundPlan/importPallet",
                    name: "multipartFile",
                    data: { id: this.baseData.headId },
                    download: ()=>{
						this.handleWebfs(process.env.VUE_APP_APIURL_FBB  + "/api/v2/TransferOutboundPlan/palletTemplate", {contextId: global.SYSID}, 'download');
                    },
                    accept: ".xls, .xlsx"
                },
                on:{
                    'on-success':(res)=>{
                        this.panelList = res.data
                        this.$emit('on-update', {type: 'panel', list: this.panelList})
                        this.modalProps.show = false;
                    },
                    'on-close': ()=>{
                        this.modalProps.show = false;
                    }
                },
            }
        },
		//查询ERPSKU
		handleSkuErp( obj ) {
			this.modalProps = {
				show: true,
				title: 'SKU',
				component: "compErpsku",
				showFooter: false,
				width: 1000,
				props: {
                    lineId: this.baseData.lineId,
                    orgWarehouseId: this.baseData.orgWarehouseId,
                    // operateType: 'amazonOut',
                    inventoryType: this.baseData.inventoryType
				},
				on: {
					'on-data': (row) => {
                        let product = this.dataList[obj];
						const { id: productId = '', sku = '', lineId = '', productName = '', productNameEn = '', inventoryAvailable = ''} = row;
                        let skuList = this.dataList.map(item=>{
                            return item.sku
                        })
                        if(skuList.includes(sku)) {
                            this.$Message.error({
                                content: this.$t('fbb.transfer.sku_exist', { defaultValue: 'SKU已存在！' }),
                                duration: 30,
                                closable: true,
                            });
                            return
                        }
                        this.$set(product, 'productId', productId);
                        this.$set(product, 'sku', sku);
                        this.$set(product, 'lineId', lineId);
                        this.$set(product, 'productName', productName);
                        this.$set(product, 'productNameEn', productNameEn);
                        this.$set(product, 'inventoryAvailable', inventoryAvailable);
                        this.update();
						this.modalProps.show = false;
					}
				},
			}
		},
		//上传数据
		handleUploadData() {
			const { orgWarehouseId, inventoryType,lineId } = this.baseData;
			const hasOrgWarehouse = orgWarehouseId || orgWarehouseId == '0';
			if (!hasOrgWarehouse) return this.$Message.warning({
                content: this.$t('fbb.alloment.fill_warehouse_and_warehouse_type',{ defaultValue: '请先填写仓库' }),
                duration: 30,
                closable: true,
            });
			this.modalProps = {
				show: true,
				title: this.$t('fbb.alloment.import_data', { defaultValue: '导入数据' }),
				component: "compUpload",
				width: 520,
				props: {
					data: { orgWarehouseId: orgWarehouseId || '', inventoryType, lineId: lineId || '' },
					action: process.env.VUE_APP_APIURL_FBB + "/api/v2/TransferOutboundPlanItem/batchImport",
					name: "excelFile",
					download: () => {
						this.handleWebfs("/static/template/Transfer_Outbound_Plan_Items.xlsx", {}, {
							executor: 'download',
							type: 'url'
						});
						// this.handleWebfs(process.env.VUE_APP_APIURL_FBB + "/api/v2/TransferOutboundPlanItem/transferOutboundPlanItemTemplate", 'download')
					},
                    accept: ".xls, .xlsx"
				},
                showFooter: false,
				on: {
					'on-success': (row) => {
						row.data.forEach((item) => {
							this.addItem({ qty: item.qty, sku: item.sku, productName: item.productName, productNameEn: item.productNameEn, lineId: item.lineId});
                            this.update();
						})
						this.modalProps.show = false;
					}
				},
			}
		},
		addItem(data) {
            let product = {qty: 0, ...data};
            this.dataList.push(product)
		},
        setPlanOutNumber(num, index){
            this.dataList[index].qty = num;
            this.getOutCount()
            this.update();
        },
        getOutCount(){
            let count = 0;
            this.dataList.map(item=>{
                count += parseInt(item.qty);
            })
            this.planOutCount=count
        },
		clearAll() {
			this.modalProps = {
				show: true,
				title: this.$tc('global.common.clear', 1, { defaultValue: '清空所有' }),
				alert: 'error',
				ajaxRequest: async () => {
                    this.dataList = [];
                    this.planOutCount = 0;
                    this.update();
					return { message: this.$t('global.common.haveto_empty', { defaultValue: '已清空' }) };
				}
			}
		},
		removeItems(obj) {
			this.modalProps = {
				show: true,
				title: this.$t('global.common.delete', { defaultValue: '删除' }),
				alert: 'warning',
				ajaxRequest: async () => {
					this.dataList.splice(obj,1)
                    this.getOutCount()
                    this.update();
					return { message: this.$t('global.common.have_deleted', { defaultValue: '已删除' }) };
				}
			}
        },
        update(){
            this.$emit('on-update', {type: 'sku', list: this.dataList})
        }

	}
}
</script>
